import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { Container } from '@/components/Container/Container';
import { ForgotPasswordForm } from '@/components/Forms/ForgotPasswordForm/ForgotPasswordForm';
import { PublicPage } from '@/components/Page/PublicPage';
import { ESize } from '@/models/enums';
import { NextPage } from 'next';

const ForgotPasswordNextPage: NextPage = () => {
  return (
    <PublicPage
      meta={{
        seoDescription: 'Please enter your email below and a reset link will be emailed to you',
        seoTitle: 'Forgot password',
      }}
      title="Forgot password"
    >
      <Container additionalClassNames="py-12" size={ESize.XS}>
        <div className="mb-2">
          <Breadcrumbs items={[{ content: <span>Forgot password</span>, key: 'forgot-password' }]} />
        </div>
        <h1 className="color-black text-uppercase mb-4">Forgot password</h1>
        <p className="mb-8">
          If you have forgotten your password, please enter your email below and a reset link will be emailed to you. If you are unsure
          about your username contact us directly and we will provide additional support.
        </p>
        <ForgotPasswordForm />
      </Container>
    </PublicPage>
  );
};

export default ForgotPasswordNextPage;
